"use client";

import type { ObjectKind } from "@engine/types";
import type { ThemeDefinition } from "@/themes/types";

/**
 * One piece of furniture, drawn in whichever theme dresses this case.
 *
 * The drawings themselves live with their themes (src/themes/<id>/icons.tsx); this only picks the
 * right one and passes the theme's palette through. The `<title>` carries the themed name, so a
 * mouse hover tells you what the thing is called in this world.
 */
export function FurnitureIcon({
  kind,
  label,
  x,
  y,
  size,
  occupiable,
  theme,
}: {
  kind: ObjectKind;
  label: string;
  x: number;
  y: number;
  size: number;
  occupiable: boolean;
  theme: ThemeDefinition;
}) {
  const Icon = theme.icons[kind];

  return (
    <g pointerEvents="none" aria-hidden="true">
      <title>{label}</title>
      <Icon x={x} y={y} size={size} occupiable={occupiable} palette={theme.colours.icon} />
    </g>
  );
}
